var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-profile"},[_c('div',{staticClass:"user-profile__icon"},[_c('Icon',{attrs:{"value":"human-profile","size":24}})],1),_c('span',{staticClass:"user-profile__name"},[_vm._v(" "+_vm._s(_vm.userName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }